import React, { useEffect, useId, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Typography,
} from "@mui/material";

const FilterSelect = ({
  label,
  fetchOptions, // Función para obtener las opciones
  options = [], // Opciones en caso de que fetchOptions no sea necesario
  value = "", // Valor seleccionado
  dependencyValue = null, // Dependencia para recargar las opciones
  onChange,
  loading: parentLoading = false, // Estado de carga externo opcional
  disabled = false,
}) => {
  const labelId = useId();
  const [localOptions, setLocalOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");

  useEffect(() => {
    if (fetchOptions && dependencyValue !== null) {
      const loadOptions = async () => {
        setLoading(true);
        const fetchedOptions = await fetchOptions();
        setLocalOptions(fetchedOptions);
        setLoading(false);
      };
      loadOptions();
    } else if (!fetchOptions) {
      setLocalOptions(options);
    }
    if (value !== null && options.length > 0) {
      const selectedOption = options.find((option) => String(option.id) === String(value));
      setSelectedValue(selectedOption);
    } else {
      setSelectedValue("");
    }
  }, [fetchOptions, dependencyValue, options, value]);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    onChange(value);
  };

  return (
    <FormControl
      fullWidth
      variant="outlined"
      sx={{
        marginTop: "16px",
        "& .MuiInputLabel-root": {
          backgroundColor: "background.paper",
          padding: "0 4px",
          color: "text.secondary",
          "&.Mui-focused": {
            backgroundColor: "background.paper",
            color: "primary.main",
          },
        },
        "& .MuiOutlinedInput-root": {
          color: "text.primary",
          backgroundColor: "transparent",
          "& .MuiSelect-select": {
            backgroundColor: "transparent",
          },
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "divider",
        },
      }}
    >
      <InputLabel
        id={labelId}
        shrink={!!selectedValue || loading || parentLoading} // Determina si flotar el texto
      >
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={selectedValue || ""}
        onChange={handleChange}
        displayEmpty
        disabled={disabled || loading || parentLoading}
      >
        {loading || parentLoading ? (
          <MenuItem disabled>
            <CircularProgress size={24} />
          </MenuItem>
        ) : localOptions.length === 0 ? (
          <MenuItem disabled>
            <Typography variant="body2" color="textSecondary">
              No hay elementos disponibles
            </Typography>
          </MenuItem>
        ) : (
          localOptions.map((option) => (
            <MenuItem key={option.id} value={option}>
              {option.name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default FilterSelect;
